import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { CSS } from 'styled-components/dist/types';

import crossIcon from '../../assets/icons/cross.svg';
import plusIcon from '../../assets/icons/plusicon.svg';
import AccordionProvider, { useAccordion } from './AccordianProvider';
// import { selectDisable } from '../../style/reusableStyle';
// import AccordionProvider, { useAccordion } from './AccordionProvider';

// interface IAccordionComposition {
//   Header: React.FC<PropsWithChildren>;
//   Content: React.FC<PropsWithChildren>;
// }

const AccordionHeaderStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

const FaqAccordion = ({
  children,
  initialValue,
}: PropsWithChildren<{ initialValue?: boolean }>) => {
  return (
    <AccordionProvider initialValue={initialValue ?? false}>
      {children}
    </AccordionProvider>
  );
};

function AccordionHeader({
  children,
  className,
  enableIcon = true,
}: PropsWithChildren<{ className?: string; enableIcon?: boolean }>) {
  const { expanded, toggle } = useAccordion();
  return (
    <AccordionHeaderStyle
      onClick={toggle}
      className={`accordion-header ${className}`}
      // style={{ backgroundColor: expanded ? '#F5F5F5' : '', padding: '10px' }}
    >
      {children}
      {enableIcon && (
        <img
          src={expanded ? crossIcon : plusIcon}
          alt="image"
          width={14}
          height={14}
          style={{
            transform: `${expanded ? 'rotate(180deg)' : 'rotate(0)'}`,
            transition: 'transform 0.2s ease-in-out',
            // backgroundColor: expanded ? 'red' : 'black',
          }}
        />
      )}
    </AccordionHeaderStyle>
  );
}

function AccordionContent({
  children,
  animationType = 'height',
}: PropsWithChildren<{ animationType?: 'display' | 'height' }>) {
  const { expanded } = useAccordion();

  const style: CSS.Properties =
    animationType === 'height'
      ? {
        maxHeight: expanded ? '800px' : '0px',
        visibility: expanded ? 'visible' : 'hidden',
        transition: 'all 0.2s ease-in-out',
        fontSize: '14px',
        // backgroundColor: expanded ? '#F5F5F5' : 'white',
      }
      : {
        display: expanded ? 'block' : 'none',
      };

  return <div style={style}>{children}</div>;
}

FaqAccordion.Header = AccordionHeader;
FaqAccordion.Content = AccordionContent;

export default FaqAccordion;
